var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-calendar',{ref:"calendar",attrs:{"type":_vm.type,"default-date":_vm.defaultDate,"formatter":_vm.formatter,"show-confirm":false,"color":_vm.color,"get-container":_vm.getContainer,"allow-same-day":_vm.allowSameDay},on:{"confirm":_vm.onConfirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})
}
var staticRenderFns = []

export { render, staticRenderFns }